<template>
    <div class="over_layout">
        <section class="upgrade">
            <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume')}}</a>
        </section>
        <section class="blog">
            <div class="wrapper">
                <div class="pages_header">
                    <div class="lines">
                        <h1>{{ category.name ? category.name : 'CVweb ' + $store.getters.t('blog') }}</h1>
                    </div>
                    <div class="description">
                        <p v-html="category.short_content"></p>
                    </div>
                </div>
                <div class="blog_block">
                    <div class="left_content">
                        <bred-crumbs :navigation="navigateUrls( category.name )"></bred-crumbs>
                        <div class="search_box">
                            <form>
                                <input class="search_input" placeholder="Search" required type="text">
                                <input class="submit_search" type="submit" value=" ">
                            </form>
                        </div>
                        <div class="title_part">
                            <span>{{ $store.getters.t('our_advices') }}</span>
                        </div>
                        <div class="all_post_blog">
                            <div class="post_type" v-for="post in posts.data" :key="post.id">
                                <div class="text_b">
                                    <router-link
                                        :to="{
                                          name: 'blog.category.post',
                                          params: {
                                            lang: $store.getters.locale,
                                            category: post.category_slug,
                                            post: post.slug,
                                          }
                                        }"
                                        class="link"
                                    >{{ post.name }}
                                    </router-link>
                                    <p v-html="post.short_content"></p>
                                    <div class="more_a">
                                        <router-link
                                            :to="{
                                              name: 'blog.category.post',
                                              params: {
                                                lang: $store.getters.locale,
                                                category: post.category_slug,
                                                post: post.slug,
                                              }
                                            }"
                                        >{{$store.getters.t('Read_more')}}...
                                        </router-link>
                                    </div>
                                </div>
                                <div class="img">
                                    <router-link
                                        :to="{
                                            name: 'blog.category.post',
                                            params: {
                                              lang: $store.getters.locale,
                                              category: post.category_slug,
                                              post: post.slug,
                                            }
                                          }"
                                    >
                                        <img :src="post.photo">
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right_sidebar">
                        <div class="fix_bar">
                            <div class="category_title">{{ $store.getters.t('category') }}</div>
                            <div class="category_list">
                                <ul>
                                    <li
                                        v-for="category in this.categories"
                                        :key="category.id"
                                        :title="category.seo_title"
                                    >
                                        <router-link
                                            active-class="active"
                                            :to="{
                                              name: 'blog.category',
                                              params: {
                                                lang: $store.getters.locale,
                                                category: category.slug
                                              }
                                            }"
                                        >{{ category.name }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <a href = "https://ru.jobsora.com/" target="_blank">Найти работу уже сейчас</a >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <template v-if="posts.last_page !== 1">
            <pagination
                v-if="this.$route.params.category"
                :data="posts"
                @pagination-change-page="getBlogCategory"
            ></pagination>
            <pagination v-else :data="posts" @pagination-change-page="getBlogList"></pagination>
        </template>
    </div>
</template>
<script>
    import pagination from "laravel-vue-pagination";
    import BredCrumbs from "../../widgets/BreadCrumbs.vue";
    import Seo from "../../../mixins/seo.js"

    export default {
        mixins: [Seo],
        components: {
            "bred-crumbs": BredCrumbs,
            pagination: pagination
        },
        data() {
            return {
                category: {},
                posts: {},
                categories: []
            };
        },
        mounted() {
            this.$parent.getData().then(changed => {
                if (changed) {
                    this.run();
                }
            });
        },
        watch: {
            $route(to, from) {
                if (
                    to.params.lang != from.params.lang ||
                    to.params.category != from.params.category
                ) {
                    this.$parent.getData().then(changed => {
                        if (changed) {
                            this.run();
                        }
                    });
                }

                if (
                    to.params.lang != from.params.lang &&
                    to.params.category == from.params.category
                ) {
                    this.$router.push({
                        name: "blog",
                        params: {
                            lang: to.params.lang
                        }
                    });
                }
            }
        },
        methods: {
            getBlogList(page = 1) {
                this.category_short_content = "";
                this.$http({
                    method: "get",
                    url: "/api/blog/list?page=" + page
                }).then(res => {
                    this.categories = res.data.categories;
                    this.category = {},
                        this.posts = res.data.activePosts;
                });
            },
            getBlogCategory(page = 1) {
                this.$http({
                    method: "get",
                    url: "/api/blog/" + this.$route.params.category + "?page=" + page
                }).then(res => {
                    this.categories = res.data.categories;
                    this.category = res.data.category;
                    this.posts = res.data.posts;
                    this.setSeo(this.category.seo_title, this.category.seo_description);
                });
            },
            run() {
                if (this.$route.params.category) {
                    this.getBlogCategory();
                } else {
                    this.getBlogList();
                }
            },
            navigateUrls(category) {
                let navigations = [];
                if (category) {
                    navigations.push(
                        {
                            title: "blog",
                            page: "blog",
                            params: {
                                lang: this.$store.getters.locale
                            }
                        },
                        {
                            title: category
                        }
                    );
                } else {
                    navigations.push({
                        title: "blog"
                    });
                }
                return navigations;
            }
        }
    };
</script>
<style>
    .pagination {
        display: -ms-flexbox;
        display: flex;
        padding-left: 0;
        list-style: none;
        border-radius: 0.25rem;
    }

    .page-item:first-child .page-link {
        margin-left: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }

    .sr-only {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/blog/Blog.vue